import ActivityTimeout from './ActivityTimeout'
import LocalStorage from './LocalStorage'
import { attivitaApi } from './attivitaApi'
import { HEARTBEAT_INTERVAL_MS, shouldSendHeartbeat } from '../Utils/tempoUtils'

class HeartbeatService {
  constructor () {
    this.interval = null
    this.lastInput = 0
    this.onInput = () => { this.lastInput = Date.now() }
  }

  init () {
    if (this.interval) return
    this.lastInput = Date.now()
    ActivityTimeout.events.forEach(e => document.addEventListener(e, this.onInput, { capture: true, passive: true }))
    this.send()
    this.interval = setInterval(() => this.send(), HEARTBEAT_INTERVAL_MS)
  }

  // Un heartbeat perso vale al massimo 60s: nessun retry né coda.
  send () {
    const ok = shouldSendHeartbeat({
      loggedIn: LocalStorage.get('user'),
      publicPage: ActivityTimeout.isOnPublicPage(),
      visible: document.visibilityState === 'visible',
      lastInput: this.lastInput,
      now: Date.now()
    })
    if (ok) attivitaApi.heartbeat()
  }

  cleanup () {
    clearInterval(this.interval)
    this.interval = null
    ActivityTimeout.events.forEach(e => document.removeEventListener(e, this.onInput, true))
  }
}

const heartbeatService = new HeartbeatService()

export default heartbeatService
